import { render, staticRenderFns } from "./UpdatePassword.vue?vue&type=template&id=2f2c27f7"
import script from "../controllers/update-password.js?vue&type=script&lang=js&external"
export * from "../controllers/update-password.js?vue&type=script&lang=js&external"
import style0 from "./UpdatePassword.vue?vue&type=style&index=0&id=2f2c27f7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports